export type EntityPrefill = {
  customer_id?: number | string | null;
  lead_id?: number | string | null;
  device_serial?: string | null;
  serial?: string | null;
  contract_id?: number | string | null;
  assignment?: string | null;
};

const PARAM_KEYS: (keyof EntityPrefill)[] = [
  "customer_id",
  "lead_id",
  "device_serial",
  "serial",
  "contract_id",
  "assignment",
];

function isNonEmpty(value: unknown): value is string | number {
  if (value == null) return false;
  if (typeof value === "string") return value.trim().length > 0;
  if (typeof value === "number") return Number.isFinite(value);
  return false;
}

/** Append non-empty entity params; preserve any query string already on path. */
export function withEntityQuery(path: string, params: EntityPrefill): string {
  const qIndex = path.indexOf("?");
  const basePath = qIndex >= 0 ? path.slice(0, qIndex) : path;
  const existingQuery = qIndex >= 0 ? path.slice(qIndex + 1) : "";
  const qs = new URLSearchParams(existingQuery);

  for (const key of PARAM_KEYS) {
    const value = params[key];
    if (isNonEmpty(value)) {
      qs.set(key, String(value));
    }
  }

  const query = qs.toString();
  return query ? `${basePath}?${query}` : basePath;
}

/** Read standard entity prefill keys from the current location search params. */
export function readEntityPrefill(searchParams: URLSearchParams): EntityPrefill {
  const get = (key: string): string | null => {
    const v = searchParams.get(key);
    return v && v.trim() ? v.trim() : null;
  };

  const deviceSerial = get("device_serial") ?? get("serial");
  const serial = get("serial") ?? get("device_serial");

  return {
    customer_id: get("customer_id"),
    lead_id: get("lead_id"),
    device_serial: deviceSerial,
    serial,
    contract_id: get("contract_id"),
    assignment: get("assignment"),
  };
}
